var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4978 5.32667C22.2066 3.85262 21.495 1.95959 21.4956 0H15.6589V23.4222C15.6139 24.6897 15.0788 25.8903 14.1662 26.7711C13.2537 27.6519 12.035 28.1443 10.7667 28.1444C8.08444 28.1444 5.85556 25.9533 5.85556 23.2333C5.85556 19.9844 8.99111 17.5478 12.2211 18.5489V12.58C5.70444 11.7111 0 16.7733 0 23.2333C0 29.5233 5.21333 34 10.7478 34C16.6789 34 21.4956 29.1833 21.4956 23.2333V11.3522C23.8623 13.0519 26.7039 13.9639 29.6178 13.9589V8.12222C29.6178 8.12222 26.0667 8.29222 23.4978 5.32667Z",
    fill: "#F9F5EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.7ade393e8a8982f3440ca885c9a07593.svg";
export { ForwardRef as ReactComponent };